import { ShowToast } from "@Components/ToastNotification/ToastNotification"
import { EventService } from "@Services/Event.Service"
import { useNavigation } from "@react-navigation/native"
import { useState } from "react"

export const useAppointmentHooks = () => {
    const [deleting, setDeleting] = useState(false)
    const navigation = useNavigation()

    const handleDeleteAppointment = ({ appointmentId, setUpdateList }) => {
        setDeleting(true)
        EventService.deleteById(appointmentId)
            .then((res) => {
                console.log({ res: res?.data })
                setDeleting(false)
                setUpdateList?.((prev) => !prev)
                ShowToast({ type: "success", message: "Opération réussie !" })
                navigation.navigate("AppointmentHome")
            })
            .catch((e) => {
                ShowToast({ type: "error", message: "Problème lors de la suppréssion du rendez-vous" })
                setDeleting(false)
            })
    }

    return {
        handleDeleteAppointment,
        deleting
    }
}
